export default __webpack_public_path__ + "static/media/profile.4ab669ac.svg";